export const researchSheet = {
    section: {
        accessFormLearner: ['learner'],
        accessFormTrainer: ['trainer', 'administrator'],
    },
};